export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
      $('#click-collect .close').on('click',function(e){
          e.preventDefault();
          //$('#click-collect').toggleClass('d-none');
          $('#click-collect').toggleClass('d-none');
          
      }); 

      if(!Cookies.get('pop-newsletter')){

        function popupNewletter() {
          
          var dialogShown = Cookies.get('dialogShown');
          
          if (!dialogShown) {    
            
            if($('#vendas-flash-modal').is(':visible')){
              
            }else{
              $('#pop-newsletter').modal('show');
              Cookies.set('pop-newsletter', 'yes');
              
              var wpcf7Elm = document.querySelector( '.modal .wpcf7' );
              wpcf7Elm.addEventListener( 'wpcf7mailsent', function( event ) {
                jQuery(".wpcf7-select").val('').selectpicker("refresh");
              }, false );
            }
            
          }
      
        }
        setTimeout(popupNewletter, 60000);
      }
    
  }, 
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js